import { ApiService, ApiServiceInterface } from "../../../../../core";
import { SearchDataResponse, SearchPageController } from "../../core";

export class SearchPageControllerImpl implements SearchPageController {
    private api: ApiServiceInterface;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(term: string): Promise<SearchDataResponse> {
        try {
            const formData = new FormData();
            formData.append("term", term);

            const data: SearchDataResponse = await this.api.post('/search-result', formData)
            return data;
        } catch (error) {
            throw new Error("Error: Method not implemented.");
        }
    }
}